import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  private apiUrl = environment.api + '/payments';

  constructor(private http: HttpClient) { }

  // Crear PaymentIntent
  paymentIntent(data: any) {
    const token = localStorage.getItem('access_token');
    const tokenType = localStorage.getItem('token_type') || 'Bearer';
    const headers = { 'Authorization': `${tokenType} ${token}` };
    return this.http.post<any>(`${this.apiUrl}/create-payment-intent`, data, { headers });
  }
  
  createPaymentIntentTransfer(data: any) {
    const token = localStorage.getItem('access_token');
    const tokenType = localStorage.getItem('token_type') || 'Bearer';
    const headers = { 'Authorization': `${tokenType} ${token}` };
    return this.http.post<any>(`${this.apiUrl}/create-payment-intent-transfer`, data, { headers });
  }


  // Obtener historial de pagos (opcional)
  getPaymentHistory(userId?: string) {
    const params = userId ? { user_id: userId } : {};
    return this.http.get<any>(`${this.apiUrl}/history`, { params });
  }

  // Obtener detalles de un pago específico (opcional)
  getPaymentDetails(paymentIntentId: string) {
    return this.http.get<any>(`${this.apiUrl}/details/${paymentIntentId}`);
  }

  hasPaid() {
    const token = localStorage.getItem('access_token');
    const tokenType = localStorage.getItem('token_type') || 'Bearer';
    const headers = new HttpHeaders({ 'Authorization': `${tokenType} ${token}` });
    return this.http.get<any>(`${this.apiUrl}/has-paid`, { headers });
  }

  // Método para establecer el flag de pago completado
  setPaymentCompleted() {
    sessionStorage.setItem('paymentJustCompleted', 'true');
    console.log('✅ Flag de pago completado establecido por PaymentsService');
  }

  // Método para verificar si hay un pago recién completado
  hasPaymentJustCompleted(): boolean {
    return sessionStorage.getItem('paymentJustCompleted') === 'true';
  }

  // Método para limpiar el flag de pago completado
  clearPaymentCompletedFlag() {
    sessionStorage.removeItem('paymentJustCompleted');
    console.log('🧹 Flag de pago completado limpiado');
  }
}
